import { useCodePreviewState } from '@cast/design-system';

import { CopyToClipboard } from '../clickable-actions/CopyToClipboard';

type CopyCodeProps = {
  color?: string;
};

export const CopyCode = ({ color = '#fff' }: CopyCodeProps) => {
  const { formattedCode } = useCodePreviewState();
  if (formattedCode === undefined) {
    return null;
  }
  return <CopyToClipboard iconSize="1em" color={color} text={formattedCode} />;
};
